var _mask, _path, _path2, _rect, _rect2, _rect3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobileIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 204,
    height: 144,
    viewBox: "0 0 204 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_606_306",
    maskUnits: "userSpaceOnUse",
    x: 65,
    y: 13,
    width: 75,
    height: 118,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 65,
    y: 13,
    width: 75,
    height: 118
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134 117C134 118.105 133.105 119 132 119L73 119C71.8954 119 71 118.105 71 117L71 29C71 26.7909 72.7909 25 75 25L130 25C132.209 25 134 26.7909 134 29L134 117Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M134 117C134 118.105 133.105 119 132 119L73 119C71.8954 119 71 118.105 71 117L71 29C71 26.7909 72.7909 25 75 25L130 25C132.209 25 134 26.7909 134 29L134 117Z",
    fill: "#00ABC5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M140 123C140 127.418 136.418 131 132 131L73 131C68.5817 131 65 127.418 65 123L77 107L128 107L140 123ZM65 23C65 17.4772 69.4772 13 75 13L130 13C135.523 13 140 17.4772 140 23L128 37L77 37L65 23ZM130 13C135.523 13 140 17.4772 140 23L140 123C140 127.418 136.418 131 132 131L128 107L128 37L130 13ZM73 131C68.5817 131 65 127.418 65 123L65 23C65 17.4772 69.4772 13 75 13L77 37L77 107L73 131Z",
    fill: "white",
    mask: "url(#path-1-outside-1_606_306)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 106,
    y: 128,
    width: 7,
    height: 7,
    rx: 3.5,
    transform: "rotate(180 106 128)",
    fill: "#00ABC5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 113,
    y: 20.8887,
    width: 14.7778,
    height: 3.88889,
    rx: 1.94444,
    transform: "rotate(180 113 20.8887)",
    fill: "#00ABC5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 95.8887,
    y: 20.8887,
    width: 3.88889,
    height: 3.88889,
    rx: 1.94444,
    transform: "rotate(180 95.8887 20.8887)",
    fill: "#00ABC5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileIcon);
export default __webpack_public_path__ + "static/media/MobileIcon.3e6321873e4424ae3843bd26f6bf7983.svg";
export { ForwardRef as ReactComponent };